module.exports = __webpack_public_path__ + "static/img/bg6.14ef83e3.png";